import { CONTACT } from "../data/apps";
import { Reveal } from "../components/Shared";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display font-semibold text-navy text-xl mb-3">{title}</h2>
    <div className="text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </div>
);

export function Privacy() {
  return (
    <LegalLayout
      testid="privacy-page"
      eyebrow="Politique de confidentialité"
      title="Comment nous protégeons vos données."
      updated="Dernière mise à jour : juin 2026"
    >
      <Section title="1. Introduction">
        <p>{CONTACT.company} (« nous ») attache une grande importance à la protection de vos données personnelles.
          Cette politique explique quelles données nous collectons via nos applications (KaGo, Une Maison Pour Tous,
          Bon Africain, CTQIBLA) et notre site {CONTACT.site}, et comment nous les utilisons.</p>
      </Section>
      <Section title="2. Données collectées">
        <p>Selon l'application utilisée, nous pouvons collecter : informations de compte (nom, e-mail, téléphone),
          données de localisation (pour le transport et la Qibla), historiques d'utilisation, annonces publiées
          et informations de paiement traitées par nos prestataires sécurisés.</p>
      </Section>
      <Section title="3. Utilisation des données">
        <p>Vos données servent à fournir et améliorer nos services, assurer la sécurité des transactions,
          personnaliser votre expérience et produire des statistiques agrégées et anonymes affichées sur ce site.</p>
      </Section>
      <Section title="4. Partage des données">
        <p>Nous ne vendons jamais vos données. Elles peuvent être partagées uniquement avec des prestataires
          techniques nécessaires au fonctionnement du service, dans le respect de la réglementation en vigueur.</p>
      </Section>
      <Section title="5. Vos droits">
        <p>Vous pouvez accéder, corriger ou supprimer vos données à tout moment en nous contactant à {CONTACT.email}.</p>
      </Section>
      <Section title="6. Contact">
        <p>Pour toute question relative à la confidentialité : {CONTACT.email} — {CONTACT.address}.</p>
      </Section>
    </LegalLayout>
  );
}

export function Terms() {
  return (
    <LegalLayout
      testid="terms-page"
      eyebrow="Conditions d'utilisation"
      title="Les règles d'utilisation de nos services."
      updated="Dernière mise à jour : juin 2026"
    >
      <Section title="1. Éditeur du site & mentions légales">
        <p>Le présent site est édité par <strong>{CONTACT.company}</strong>, société à responsabilité limitée (SARL) de droit malien.</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Gérant / Responsable : {CONTACT.manager}</li>
          <li>Forme juridique : {CONTACT.legalForm}</li>
          <li>Siège social : {CONTACT.registeredOffice}</li>
          <li>RCCM : {CONTACT.rccm} (immatriculée le {CONTACT.rccmDate})</li>
          <li>N° d'Immatriculation National (NINA) : {CONTACT.nina}</li>
          <li>Contact : {CONTACT.email} — {CONTACT.phone}</li>
        </ul>
      </Section>
      <Section title="2. Acceptation des conditions">
        <p>En utilisant les applications et le site de {CONTACT.company}, vous acceptez les présentes conditions
          d'utilisation. Si vous n'êtes pas d'accord, veuillez ne pas utiliser nos services.</p>
      </Section>
      <Section title="3. Services proposés">
        <p>TIRERA GROUP propose plusieurs applications : KaGo (transport et livraison), Une Maison Pour Tous (immobilier),
          Bon Africain (marketplace) et CTQIBLA (services islamiques), ainsi que TIRERA Construction & Habitat. Chaque service peut disposer de conditions
          spécifiques complémentaires.</p>
      </Section>
      <Section title="4. Compte utilisateur">
        <p>Vous êtes responsable de l'exactitude des informations fournies et de la confidentialité de vos
          identifiants. Toute activité réalisée depuis votre compte relève de votre responsabilité.</p>
      </Section>
      <Section title="5. Utilisation acceptable">
        <p>Il est interdit d'utiliser nos services à des fins illégales, frauduleuses ou portant atteinte aux
          droits d'autrui. Nous nous réservons le droit de suspendre tout compte en cas de non-respect.</p>
      </Section>
      <Section title="6. Responsabilité">
        <p>Nos services sont fournis « en l'état ». TIRERA GROUP met tout en œuvre pour garantir leur fiabilité
          mais ne saurait être tenu responsable des interruptions ou des contenus publiés par les utilisateurs.</p>
      </Section>
      <Section title="7. Contact">
        <p>Pour toute question : {CONTACT.email} — {CONTACT.address}.</p>
      </Section>
    </LegalLayout>
  );
}

const LegalLayout = ({ testid, eyebrow, title, updated, children }) => (
  <main data-testid={testid} className="pt-[70px]">
    <section className="mx-auto max-w-3xl px-5 sm:px-8 pt-16 lg:pt-24 pb-24">
      <Reveal>
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{eyebrow}</div>
        <h1 className="mt-4 font-display font-semibold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">{title}</h1>
        <p className="mt-3 text-sm text-muted-foreground">{updated}</p>
      </Reveal>
      <Reveal i={1}>
        <div className="mt-12">{children}</div>
      </Reveal>
    </section>
  </main>
);
